import React from 'react';
import styled from 'styled-components';
import {IconoirArrowUp, IconoirArrowDown} from '@ey-xd/motif-icon';
import {convertToDecimal} from '../../AccountOverview/index';
import {displayValue} from '../../AccountOverview/indexDisplayValue';
import {financialStatementType} from '../../../../../../../../util/uiconstants';
import {isNullOrUndefined} from '../../../../../../../../util/utils';
import {useUserPreferences} from '../../../../../../../../util/customHooks';

export default function XTE(params) {
	const data = params.data;
	const userPreferences = useUserPreferences();
	const xTE =
		params.materiality?.teAmount > 0 && !isNullOrUndefined(params.value)
			? convertToDecimal(params.value / params.materiality?.teAmount, false, false)
			: undefined;

	let abs = Math.abs(xTE);
	if (abs > 9999.99) {
		abs = 9999.99;
	}

	const fomattedNumber = displayValue(
		abs,
		false,
		true,
		false,
		'x',
		2,
		undefined,
		undefined,
		undefined,
		userPreferences,
		IconoirArrowUp,
		IconoirArrowDown
	);

	return (
		data?.financialStatementSubTypeId === financialStatementType.AccountType && (
			<StyledNumberColumn className="StyledNumberColumn">{fomattedNumber}</StyledNumberColumn>
		)
	);
}

const StyledNumberColumn = styled.section`
	font-size: var(--px-14);
	font-weight: 400;
	line-height: var(--px-22);
	display: flex;
	justify-content: center;
`;
